import { useContext } from 'react';
import { ApptRequestIvStatusDialogContext } from './context';

export const useApptRequestIvStatusDialog = () => {
  const context = useContext(ApptRequestIvStatusDialogContext);

  if (!context) throw new Error('useApptRequestIvStatusDialog called outside ApptRequestIvStatusDialogContext');

  return context;
};
